import styled from 'styled-components';

export const Container = styled.div<{
  paddingBottom?: string;
}>`
  display: flex;
  flex-direction: column;
  padding-bottom: ${(props) => props.paddingBottom ?? '16px'};
  gap: 4px;
  width: 100%;

  .separator-line {
    width: 100%;
    height: 1px;
    background-color: #d5e5f0;
  }
`;

export const ContainerItems = styled.div<{
  alingItem?: string;
  iconSize?: number;
  disabled?: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: ${(props) => props.alingItem ?? 'center'};
  justify-content: start;
  padding-top: 8px;
  padding-bottom: 8px;
  gap: 8px;
  width: 100%;
  height: auto;

  > img {
    width: ${(props) => props.iconSize ?? 16}px;
    height: ${(props) => props.iconSize ?? 16}px;
  }
`;

export const ItemText = styled.p`
  color: #161d1f;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;
